var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-351 153 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-272.8,277c-11.8,0-21.1-9.4-21.1-21.1s9.4-21.1,21.1-21.1c11.4,0,21.1,9.4,21.1,21.1S-261.1,277-272.8,277z M-318.5,304.5 v8.3h91.7v-8.3c0-13.5-9.7-21.1-23.2-21.1h-45.3C-308.5,283.3-318.5,291-318.5,304.5z M-133.8,239.5h-74.9v14.2h74.9V239.5z  M-133.8,269h-74.9v14.3h74.9V269z M-133.8,298.8h-74.9v14.3h74.9V298.8z M-325.8,191.1h205.6c11.3,0,20.6,9.2,20.6,20.6v113.1 c0,11.3-9.2,20.6-20.6,20.6h-205.6c-11.3,0-20.6-9.2-20.6-20.6V211.6C-346.3,200.3-337.1,191.1-325.8,191.1z M-332.6,324.7 c0,3.8,3.1,6.9,6.9,6.9h205.6c3.8,0,6.9-3.1,6.9-6.9V211.6c0-3.8-3.1-6.9-6.9-6.9h-205.6c-3.8,0-6.9,3.1-6.9,6.9V324.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDetails);
export default __webpack_public_path__ + "static/media/profile-details.0cd6203334bd65afc04d4f01ecdc5eb0.svg";
export { ForwardRef as ReactComponent };